import { useState } from 'react';
import { useScrollAnimation, useStaggerAnimation } from '../../hooks/useScrollAnimation';

export default function ShopPage() {
  const [priceRange, setPriceRange] = useState([0, 200]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('featured');
  const [wishlist, setWishlist] = useState<number[]>([]);
  const [showFilters, setShowFilters] = useState(false);

  const headerAnim = useScrollAnimation({ threshold: 0.1 });
  const productsStagger = useStaggerAnimation(9, { threshold: 0.05 });

  const toggleWishlist = (id: number) => {
    setWishlist((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const products = [
    {
      id: 1,
      name: 'Premium CBD Oil 1000mg',
      category: 'CBD Products',
      price: 49.99,
      originalPrice: 69.99,
      rating: 4.8,
      reviews: 234,
      image: 'https://public.readdy.ai/ai/img_res/ba29f5a8a30ad293dca86bede32bce57.jpg',
      badge: 'Best Seller'
    },
    {
      id: 2,
      name: 'Organic Hemp Seeds - Premium Strain',
      category: 'Seeds',
      price: 89.99,
      originalPrice: 119.99,
      rating: 4.9,
      reviews: 189,
      image: 'https://readdy.ai/api/search-image?query=premium%20cannabis%20hemp%20seeds%20in%20elegant%20glass%20jar%20on%20natural%20wood%20surface%20with%20soft%20green%20leaves%20around%20clean%20white%20background%20professional%20product%20photography%20organic%20natural%20aesthetic%20high%20end%20wellness%20branding&width=400&height=500&seq=seed001&orientation=portrait',
      badge: 'Organic'
    },
    {
      id: 3,
      name: 'Natural Organic Fertilizer Kit',
      category: 'Growing Supplies',
      price: 34.99,
      originalPrice: 49.99,
      rating: 4.7,
      reviews: 156,
      image: 'https://readdy.ai/api/search-image?query=organic%20fertilizer%20bottles%20and%20natural%20soil%20amendments%20on%20clean%20white%20surface%20with%20green%20plant%20sprouts%20professional%20product%20photography%20eco%20friendly%20packaging%20minimalist%20natural%20aesthetic%20wellness%20gardening%20products&width=400&height=500&seq=fert001&orientation=portrait',
      badge: 'Eco-Friendly'
    },
    {
      id: 4,
      name: 'CBD Wellness Capsules 30ct',
      category: 'CBD Products',
      price: 39.99,
      originalPrice: 54.99,
      rating: 4.6,
      reviews: 298,
      image: 'https://readdy.ai/api/search-image?query=elegant%20white%20bottle%20of%20CBD%20wellness%20capsules%20on%20marble%20surface%20with%20fresh%20green%20cannabis%20leaves%20clean%20white%20background%20professional%20product%20photography%20premium%20supplement%20packaging%20natural%20health%20aesthetic&width=400&height=500&seq=caps001&orientation=portrait',
      badge: 'New'
    },
    {
      id: 5,
      name: 'Full Spectrum CBD Tincture',
      category: 'CBD Products',
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 412,
      image: 'https://readdy.ai/api/search-image?query=premium%20dark%20amber%20CBD%20tincture%20bottle%20with%20gold%20label%20on%20white%20marble%20with%20green%20hemp%20leaves%20professional%20product%20photography%20luxury%20wellness%20product%20clean%20minimalist%20composition%20natural%20lighting&width=400&height=500&seq=tinc001&orientation=portrait',
      badge: 'Best Seller'
    },
    {
      id: 6,
      name: 'CBD Sleep Support Gummies',
      category: 'CBD Products',
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 267,
      image: 'https://readdy.ai/api/search-image?query=premium%20CBD%20gummy%20supplements%20in%20clear%20glass%20jar%20on%20white%20marble%20with%20green%20leaves%20professional%20product%20photography%20natural%20wellness%20aesthetic%20clean%20minimalist%20background%20soft%20lighting%20high%20quality&width=400&height=500&seq=gummy001&orientation=portrait',
      badge: 'Popular'
    },
    {
      id: 7,
      name: 'Organic Growing Medium - 5L',
      category: 'Growing Supplies',
      price: 24.99,
      originalPrice: 34.99,
      rating: 4.8,
      reviews: 178,
      image: 'https://readdy.ai/api/search-image?query=premium%20organic%20soil%20growing%20medium%20in%20eco%20friendly%20bag%20with%20green%20plant%20seedlings%20on%20natural%20wood%20surface%20professional%20product%20photography%20sustainable%20gardening%20clean%20white%20background%20natural%20aesthetic&width=400&height=500&seq=soil001&orientation=portrait',
      badge: 'Organic'
    },
    {
      id: 8,
      name: 'LED Grow Light - Full Spectrum',
      category: 'Growing Supplies',
      price: 149.99,
      originalPrice: 199.99,
      rating: 4.7,
      reviews: 145,
      image: 'https://readdy.ai/api/search-image?query=modern%20LED%20grow%20light%20panel%20with%20purple%20and%20white%20lights%20illuminating%20green%20cannabis%20plants%20professional%20product%20photography%20clean%20white%20background%20high%20tech%20gardening%20equipment%20minimalist%20composition&width=400&height=500&seq=light001&orientation=portrait',
      badge: 'Tech'
    },
    {
      id: 9,
      name: 'CBD Pain Relief Cream',
      category: 'Wellness',
      price: 44.99,
      originalPrice: 59.99,
      rating: 4.6,
      reviews: 223,
      image: 'https://readdy.ai/api/search-image?query=premium%20white%20jar%20of%20CBD%20pain%20relief%20cream%20on%20marble%20surface%20with%20green%20cannabis%20leaves%20professional%20product%20photography%20luxury%20skincare%20packaging%20clean%20minimalist%20aesthetic%20natural%20wellness%20product&width=400&height=500&seq=cream001&orientation=portrait',
      badge: 'Wellness'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Products', count: products.length },
    { id: 'cbd', name: 'CBD Products', count: 5 },
    { id: 'seeds', name: 'Seeds', count: 1 },
    { id: 'supplies', name: 'Growing Supplies', count: 3 },
    { id: 'wellness', name: 'Wellness', count: 1 }
  ];

  return (
    <div className="min-h-screen bg-white pt-20 overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-4 py-6 md:py-12">
        {/* Header */}
        <div
          ref={headerAnim.ref as React.RefObject<HTMLDivElement>}
          className="mb-6 md:mb-8 transition-all duration-700"
          style={{
            opacity: headerAnim.isVisible ? 1 : 0,
            transform: headerAnim.isVisible ? 'translateY(0)' : 'translateY(30px)'
          }}
        >
          <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
            <a href="/" className="hover:text-[#2D5F3F] transition-colors cursor-pointer">Home</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-[#2D5F3F] font-semibold">Shop</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-[#2C2C2C] mb-3 md:mb-4">Premium Cannabis Wellness Products</h1>
          <p className="text-base md:text-lg text-gray-600">Discover our curated collection of organic CBD products, seeds, and growing supplies</p>
        </div>

        {/* Age & Legal Compliance Notice */}
        <div className="bg-[#1A3A2A] text-white rounded-xl px-6 py-5 mb-8 flex flex-col md:flex-row items-start md:items-center gap-4 shadow-md">
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#D4AF37]/20 border border-[#D4AF37]/40">
              <i className="ri-shield-check-line text-[#D4AF37] text-xl"></i>
            </div>
            <span className="text-[#D4AF37] font-bold text-sm uppercase tracking-widest whitespace-nowrap">Age &amp; Legal Notice</span>
          </div>
          <div className="h-px w-full md:h-8 md:w-px bg-white/20 flex-shrink-0"></div>
          <div className="flex flex-col sm:flex-row gap-4 text-sm text-white/90 leading-relaxed">
            <div className="flex items-start gap-2">
              <i className="ri-user-age-line text-[#D4AF37] text-base mt-0.5 flex-shrink-0"></i>
              <span>
                <strong className="text-white">You must be of legal age</strong> in your jurisdiction to purchase cannabis-related products. By shopping here, you confirm you meet the minimum age requirement in your location.
              </span>
            </div>
            <div className="hidden sm:block w-px bg-white/20 flex-shrink-0"></div>
            <div className="flex items-start gap-2">
              <i className="ri-global-line text-[#D4AF37] text-base mt-0.5 flex-shrink-0"></i>
              <span>
                <strong className="text-white">We only ship where it's legal.</strong> Orders are fulfilled exclusively to regions where the purchase and possession of these products is permitted by law. It is your responsibility to know your local regulations.
              </span>
            </div>
          </div>
        </div>

        {/* Mobile Filter Toggle Button */}
        <button
          onClick={() => setShowFilters(true)}
          className="lg:hidden w-full bg-[#2D5F3F] text-white py-3 rounded-lg font-semibold mb-6 flex items-center justify-center gap-2 hover:bg-[#1A3A2A] transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-filter-3-line text-xl"></i>
          Show Filters
        </button>

        <div className="flex gap-8">
          {/* Sidebar - Desktop */}
          <aside className="hidden lg:block w-72 flex-shrink-0">
            <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24 transition-all duration-300 hover:shadow-xl">
              <h3 className="text-xl font-bold text-[#2C2C2C] mb-6">Filters</h3>

              <div className="mb-8">
                <h4 className="text-base font-semibold text-[#2C2C2C] mb-4">Product Type</h4>
                <div className="space-y-3">
                  {categories.map((category) => (
                    <label key={category.id} className="flex items-center gap-3 cursor-pointer group">
                      <input
                        type="radio"
                        name="category"
                        checked={selectedCategory === category.id}
                        onChange={() => setSelectedCategory(category.id)}
                        className="w-5 h-5 text-[#2D5F3F] focus:ring-[#2D5F3F] cursor-pointer"
                      />
                      <span className="text-sm text-gray-700 group-hover:text-[#2D5F3F] transition-colors flex-1">
                        {category.name}
                      </span>
                      <span className="text-xs text-gray-400 group-hover:text-[#D4AF37] transition-colors">({category.count})</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-8">
                <h4 className="text-base font-semibold text-[#2C2C2C] mb-4">Price Range</h4>
                <div className="space-y-4">
                  <input
                    type="range"
                    min="0"
                    max="200"
                    value={priceRange[1]}
                    onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-[#2D5F3F]"
                  />
                  <div className="flex items-center justify-between text-sm text-gray-600">
                    <span>${priceRange[0]}</span>
                    <span className="font-semibold text-[#2D5F3F]">${priceRange[1]}</span>
                  </div>
                </div>
              </div>

              <div className="mb-8">
                <h4 className="text-base font-semibold text-[#2C2C2C] mb-4">Certifications</h4>
                <div className="space-y-3">
                  {['Organic Certified', 'Lab Tested', 'Non-GMO', 'Vegan'].map((cert) => (
                    <label key={cert} className="flex items-center gap-3 cursor-pointer group">
                      <input
                        type="checkbox"
                        className="w-5 h-5 text-[#2D5F3F] rounded focus:ring-[#2D5F3F] cursor-pointer"
                      />
                      <span className="text-sm text-gray-700 group-hover:text-[#2D5F3F] transition-colors">
                        {cert}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              <button className="w-full bg-[#2D5F3F] text-white py-3 rounded-lg font-semibold hover:bg-[#1A3A2A] hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 mb-3 whitespace-nowrap cursor-pointer">
                Apply Filters
              </button>
              <button className="w-full text-[#2D5F3F] text-sm font-semibold hover:text-[#D4AF37] transition-colors cursor-pointer whitespace-nowrap">
                Clear All
              </button>
            </div>
          </aside>

          {/* Mobile Filter Drawer Overlay */}
          {showFilters && (
            <div className="lg:hidden fixed inset-0 z-50 bg-black/50" onClick={() => setShowFilters(false)}>
              <div
                className="absolute left-0 top-0 bottom-0 w-80 max-w-[85vw] bg-white shadow-2xl overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl font-bold text-[#2C2C2C]">Filters</h3>
                    <button
                      onClick={() => setShowFilters(false)}
                      className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                    >
                      <i className="ri-close-line text-2xl text-gray-600"></i>
                    </button>
                  </div>

                  <div className="mb-8">
                    <h4 className="text-base font-semibold text-[#2C2C2C] mb-4">Product Type</h4>
                    <div className="space-y-3">
                      {categories.map((category) => (
                        <label key={category.id} className="flex items-center gap-3 cursor-pointer group">
                          <input
                            type="radio"
                            name="category-mobile"
                            checked={selectedCategory === category.id}
                            onChange={() => setSelectedCategory(category.id)}
                            className="w-5 h-5 text-[#2D5F3F] focus:ring-[#2D5F3F] cursor-pointer"
                          />
                          <span className="text-sm text-gray-700 group-hover:text-[#2D5F3F] transition-colors flex-1">
                            {category.name}
                          </span>
                          <span className="text-xs text-gray-400 group-hover:text-[#D4AF37] transition-colors">({category.count})</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="mb-8">
                    <h4 className="text-base font-semibold text-[#2C2C2C] mb-4">Price Range</h4>
                    <div className="space-y-4">
                      <input
                        type="range"
                        min="0"
                        max="200"
                        value={priceRange[1]}
                        onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
                        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-[#2D5F3F]"
                      />
                      <div className="flex items-center justify-between text-sm text-gray-600">
                        <span>${priceRange[0]}</span>
                        <span className="font-semibold text-[#2D5F3F]">${priceRange[1]}</span>
                      </div>
                    </div>
                  </div>

                  <div className="mb-8">
                    <h4 className="text-base font-semibold text-[#2C2C2C] mb-4">Certifications</h4>
                    <div className="space-y-3">
                      {['Organic Certified', 'Lab Tested', 'Non-GMO', 'Vegan'].map((cert) => (
                        <label key={cert} className="flex items-center gap-3 cursor-pointer group">
                          <input
                            type="checkbox"
                            className="w-5 h-5 text-[#2D5F3F] rounded focus:ring-[#2D5F3F] cursor-pointer"
                          />
                          <span className="text-sm text-gray-700 group-hover:text-[#2D5F3F] transition-colors">
                            {cert}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <button
                    onClick={() => setShowFilters(false)}
                    className="w-full bg-[#2D5F3F] text-white py-3 rounded-lg font-semibold hover:bg-[#1A3A2A] transition-all duration-300 mb-3 whitespace-nowrap cursor-pointer"
                  >
                    Apply Filters
                  </button>
                  <button className="w-full text-[#2D5F3F] text-sm font-semibold hover:text-[#D4AF37] transition-colors cursor-pointer whitespace-nowrap">
                    Clear All
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Products Grid */}
          <main className="flex-1">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 md:mb-8 gap-4">
              <p className="text-sm text-gray-600">
                Showing <strong>{products.length}</strong> of <strong>{products.length}</strong> products
              </p>
              <div className="flex items-center gap-3 w-full sm:w-auto">
                <label className="text-sm text-gray-600 whitespace-nowrap">Sort by:</label>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="flex-1 sm:flex-none px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#2D5F3F] cursor-pointer hover:border-[#2D5F3F] transition-colors duration-200"
                >
                  <option value="featured">Featured</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                  <option value="rating">Highest Rated</option>
                  <option value="newest">Newest</option>
                </select>
              </div>
            </div>

            <div
              ref={productsStagger.ref as React.RefObject<HTMLDivElement>}
              className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-12"
              data-product-shop
            >
              {products.map((product, index) => (
                <div
                  key={product.id}
                  className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-400 overflow-hidden group cursor-pointer hover:-translate-y-3"
                  style={{
                    opacity: productsStagger.visibleItems[index] ? 1 : 0,
                    transform: productsStagger.visibleItems[index]
                      ? 'translateY(0) scale(1)'
                      : 'translateY(40px) scale(0.96)',
                    transition: 'opacity 0.5s ease-out, transform 0.5s ease-out, box-shadow 0.3s'
                  }}
                >
                  <div className="relative w-full h-64 md:h-80 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-600"
                    />
                    {product.badge && (
                      <span className="absolute top-3 md:top-4 left-3 md:left-4 px-2 md:px-3 py-1 bg-[#D4AF37] text-white text-xs font-bold rounded-full shadow-md">
                        {product.badge}
                      </span>
                    )}
                    {/* Wishlist button */}
                    <button
                      onClick={() => toggleWishlist(product.id)}
                      className="absolute top-3 md:top-4 right-3 md:right-4 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center shadow-md opacity-0 group-hover:opacity-100 hover:scale-110 transition-all duration-300 cursor-pointer"
                    >
                      <i className={`${wishlist.includes(product.id) ? 'ri-heart-fill text-red-500' : 'ri-heart-line text-gray-500'} text-base`}></i>
                    </button>
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <button className="bg-white text-[#2D5F3F] px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold hover:bg-[#D4AF37] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer translate-y-4 group-hover:translate-y-0 transition-transform text-sm md:text-base">
                        Quick View
                      </button>
                    </div>
                  </div>
                  <div className="p-4 md:p-6 relative">
                    <span className="inline-block px-3 md:px-4 py-1 bg-[#2D5F3F]/10 text-[#2D5F3F] text-xs font-semibold rounded-full mb-2 md:mb-3">
                      {product.category}
                    </span>
                    <h3 className="text-base md:text-lg font-semibold text-[#2C2C2C] mb-2 line-clamp-2 min-h-[3rem] md:min-h-[3.5rem] group-hover:text-[#2D5F3F] transition-colors duration-300">
                      {product.name}
                    </h3>
                    <div className="flex items-center gap-2 mb-2 md:mb-3">
                      <div className="flex items-center gap-1">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`${i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'} text-[#D4AF37] text-xs md:text-sm`}
                          ></i>
                        ))}
                      </div>
                      <span className="text-xs text-gray-500">({product.reviews})</span>
                    </div>
                    <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                      <span className="text-xl md:text-2xl font-bold text-[#2D5F3F]">${product.price}</span>
                      <span className="text-xs md:text-sm text-gray-400 line-through">${product.originalPrice}</span>
                      <span className="text-xs font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                        {Math.round((1 - product.price / product.originalPrice) * 100)}% OFF
                      </span>
                    </div>
                    <button className="absolute bottom-4 md:bottom-6 right-4 md:right-6 w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#2D5F3F] text-white flex items-center justify-center hover:bg-[#D4AF37] hover:scale-110 hover:rotate-12 transition-all duration-300 cursor-pointer shadow-md hover:shadow-lg">
                      <i className="ri-shopping-cart-line text-lg md:text-xl"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Affiliate Banner */}
            <div className="flex flex-col items-center gap-3 my-10">
              <p className="text-xs text-gray-400 uppercase tracking-widest font-semibold">Our Partners</p>
              <a
                href="https://www.cannatop100.com?a_aid=ElixirSue&a_bid=ebcdd1a5"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block hover:opacity-80 transition-opacity duration-300 cursor-pointer"
              >
                <img
                  src="https://www.greenaffiliates.com/accounts/default1/nxkkkeyb/ebcdd1a5.png"
                  alt="CannaTOP 100 - Top Cannabis Sites"
                  title="CannaTOP 100"
                  width={728}
                  height={90}
                  className="mx-auto rounded-lg shadow-md max-w-full"
                />
              </a>
              <img
                alt=""
                src="https://www.greenaffiliates.com/scripts/nxkkkeyi?a_aid=ElixirSue&a_bid=ebcdd1a5"
                width={1}
                height={1}
              />
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-center gap-2">
              <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-[#2D5F3F] hover:text-white hover:border-[#2D5F3F] hover:scale-110 transition-all duration-300 cursor-pointer">
                <i className="ri-arrow-left-s-line"></i>
              </button>
              {[1, 2, 3, 4].map((page) => (
                <button
                  key={page}
                  className={`w-10 h-10 flex items-center justify-center rounded-lg font-semibold transition-all duration-300 cursor-pointer hover:scale-110 ${
                    page === 1
                      ? 'bg-[#2D5F3F] text-white shadow-md'
                      : 'border border-gray-300 text-gray-600 hover:bg-[#2D5F3F] hover:text-white hover:border-[#2D5F3F]'
                  }`}
                >
                  {page}
                </button>
              ))}
              <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-[#2D5F3F] hover:text-white hover:border-[#2D5F3F] hover:scale-110 transition-all duration-300 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
